import styled from "styled-components";

export const Corpo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  min-width: 0;

  .barra{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px;

    .busca{ flex: 1 1 280px; min-width: 0; }
    .busca .form-group{ margin: 0; }

    .novo{
      width: auto;
      height: 40px;
      margin: 0 0 0 auto !important;
      padding: 0 18px;
      font-size: 13px;
      font-weight: 600;
      border-radius: 6px;
      cursor: pointer;
      background: var(--primary-color);
      color: #fff;
      border: none;
    }
  }

  .resumo{ font-size: 12px; color: #4D4F50; }
  .erro-lista{ font-size: 12px; color: #C43333; }
  .vazio{ padding: 28px 0; text-align: center; font-size: 13px; color: #4D4F50; }

  .more{
    color: var(--primary-color);
    width: 100%;
    display: flex;
    justify-content: center;
    cursor: pointer;
    background: transparent;
    border: none;
    margin: 4px 0 0;
    font-size: 14px;
    &:hover{ font-weight: bold; }
  }

  /* ---- células ---- */
  .nome{ font-weight: 600; font-size: 14px; overflow-wrap: anywhere; }
  .meta{ font-size: 12px; color: #4D4F50; overflow-wrap: anywhere; }
  .cientifico{ font-style: italic; font-size: 13px; overflow-wrap: anywhere; }

  .link{
    font-size: 12px;
    color: var(--primary-color);
    overflow-wrap: anywhere;
    text-decoration: underline;
  }

  .miniatura{
    width: 96px;
    height: 54px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #E1E3E6;
    background: #F7F8F9;
  }
  .foto{
    /* quadrado FIXO: sem isso a celula estreita espremia a largura e o circulo virava oval */
    flex: none;
    display: block;
    width: 44px;
    min-width: 44px;
    max-width: 44px;
    height: 44px;
    min-height: 44px;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 50%;
    border: 1px solid var(--primary-color);
    background: #F7F8F9;
  }
  .sem-imagem{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 96px;
    height: 54px;
    border-radius: 6px;
    border: 1px dashed #C9CCD0;
    font-size: 10px;
    color: #6B6E70;
  }

  .chips{ display: flex; flex-wrap: wrap; gap: 4px; }
  .chip{
    padding: 1px 8px;
    border-radius: 10px;
    font-size: 11px;
    background: #E4F4E7;
    color: #1f7a33;
    border: 1px solid #BFE0C5;
  }

  .selo{
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid transparent;
    &.Ativo{ background: #fff; color: #1f7a33; border-color: #BFE0C5; }
    &.Inativo{ background: #FDF3F3; color: #A12A2A; border-color: #F0CACA; }
    &.Pendente{ background: #FFF7E5; color: #8A5A00; border-color: #F0DBA8; }
    &.origem-app{ background: #E8EEF5; color: #26466D; border-color: #C6D3E3; }
    &.origem-manual{ background: #F1F2F4; color: #4D4F50; border-color: #DDDFE3; }
  }

  .acoes{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;

    button, a{
      display: inline-flex;
      align-items: center;
      width: auto;
      height: 28px;
      margin: 0 !important;
      padding: 0 12px;
      font-size: 11px;
      border-radius: 4px;
      cursor: pointer;
      background: transparent;
      color: var(--primary-color);
      border: 1.2px solid var(--primary-color);
      text-decoration: none;
    }
    button:focus-visible, a:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
    .perigo{ color: #C43333; border-color: #C43333; }
  }

`;


// ------------------------------------------------------------------ Índice

export const Cartoes = styled.nav`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
  width: 100%;

  .celula{ display: flex; flex-direction: column; gap: 8px; }
  .celula > a.cartao{ flex: 1; }

  a.atalho{
    align-self: flex-start;
    font-size: 13px;
    font-weight: 600;
    color: var(--primary-color);
    text-decoration: none;
    &:hover{ text-decoration: underline; }
    &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; border-radius: 2px; }
  }

  a.cartao{
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-height: 150px;
    padding: 20px;
    border-radius: 8px;
    border: 1.5px solid #EFF0F2;
    background: #FEFEFE;
    color: inherit;
    text-decoration: none;

    &:hover{ border-color: var(--primary-color); }
    &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }

    h3{ margin: 0; font-size: 18px; font-weight: 700; }
    p{ margin: 0; font-size: 13px; color: #4D4F50; flex: 1; }

    .numero{ font-size: 28px; font-weight: 700; line-height: 1.1; }
    .numero small{ font-size: 12px; font-weight: 500; color: #4D4F50; margin-left: 6px; }
    .abrir{ font-size: 13px; font-weight: 600; color: var(--primary-color); }
  }
`;

// ------------------------------------------------------------------ Migalhas

export const Migalhas = styled.nav`
  ol{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 13px;
    color: #4D4F50;
  }

  li + li::before{ content: "›"; margin-right: 6px; color: #8B8E90; }

  a{ color: var(--primary-color); text-decoration: none; font-weight: 600; }
  a:hover{ text-decoration: underline; }
  a:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; border-radius: 2px; }

  [aria-current="page"]{ color: #111; font-weight: 600; }
`;

// -------------------------------------------------------------------- Aviso

export const Aviso = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 13px;
  background: #F1F8F2;
  border: 1px solid #CFE6D3;
  color: #1f7a33;

  &.erro{ background: #FDF3F3; border-color: #F0CACA; color: #A12A2A; }

  button{
    width: auto;
    height: auto;
    margin: 0 !important;
    padding: 2px 8px;
    border: none;
    background: transparent;
    color: inherit;
    font-size: 16px;
    cursor: pointer;
  }
`;

// --------------------------------------------------------------- Formulário

export const FormPagina = styled.div`
  width: 100%;
  max-width: 1040px;
  padding-bottom: 24px;

  /* Sem pré-visualização (bioma, espécie, formulário do apoiador) o formulário
     fica numa coluna estreita; com ela, o formulário e o "Como aparece" lado a
     lado e, sem espaço, um sobre o outro (flex-wrap, sem media query). */
  > form{ max-width: 680px; }

  .layout-form{
    display: flex;
    flex-wrap: wrap;
    gap: 24px 32px;
    align-items: flex-start;

    > form{ flex: 1 1 420px; min-width: 0; max-width: 640px; }
  }

  .previa-lateral{
    flex: 1 1 260px;
    max-width: 340px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border: 1.5px solid #EFF0F2;
    border-radius: 8px;
    background: #FEFEFE;

    h3{ margin: 0; font-size: 14px; font-weight: 700; }
    .sub{ font-size: 11px; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; color: #4D4F50; }

    .moldura{
      margin-top: 6px;
      width: 100%;
      overflow: hidden;
      border-radius: 8px;
      border: 1px solid #E1E3E6;
      background: #F7F8F9;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #6B6E70;

      img{ width: 100%; height: 100%; object-fit: cover; display: block; }
      /* Medida real: no site o banner tem 215 px de altura e ~330 px de largura (CardApoiador). */
      &.site{ aspect-ratio: 330 / 215; }
      &.app{ aspect-ratio: 327 / 176; }
    }

    .cartao-app{
      margin-top: 6px;
      padding: 16px;
      border-radius: 16px;
      background: #F9FAF9;
      display: flex;
      flex-direction: column;
      gap: 12px;

      .perfil{ display: flex; align-items: center; gap: 12px; }
      .avatar{ width: 40px; height: 40px; border-radius: 50%; object-fit: cover; border: 1px solid var(--primary-color); background: #F7F8F9; flex-shrink: 0; }
      .nome{ font-size: 14px; font-weight: 700; overflow-wrap: anywhere; }
      .local{ display: flex; align-items: center; gap: 4px; font-size: 12px; img{ width: 12px; } }
      .desc{ font-size: 13px; overflow-wrap: anywhere; }
    }
  }

  /* Apoiador vindo do app: aviso de que nome/estado/foto são do perfil e campos só de leitura. */
  .somente-leitura{
    margin: 0 0 16px;
    padding: 10px 12px;
    border-radius: 8px;
    background: #F4F8FC;
    border: 1px solid #DDE6F0;
    font-size: 13px;
    line-height: 1.45;
    color: #3D4A5C;
  }
  input.somente-leitura-campo{ background: #F1F2F4; color: #4D4F50; cursor: not-allowed; }

  /* O Formulario do projeto dá altura de campo de 42px a TODO input: os
     checkboxes e o campo de arquivo precisam escapar disso. */
  input[type="checkbox"]{ height: 18px; width: 18px; margin: 0; padding: 0; accent-color: var(--primary-color); }
  input[type="file"]{ height: auto; padding: 8px 0; border: none; }

  textarea{
    min-height: 96px;
    padding: 10px 12px !important;
    resize: vertical;
    font-family: inherit;
  }

  .ajuda{ margin: 4px 0 0 5px; font-size: 11px; color: #6B6E70; }

  fieldset{
    margin: 18px 0 0;
    padding: 0;
    border: none;
    min-width: 0;

    legend{ padding: 0; font-weight: 700; font-size: 12px; }
    &.com-erro .lista-biomas{ border-color: #C43333; }
  }

  .lista-biomas{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 10px 16px;
    margin-top: 12px;
    padding: 14px;
    border: 1px solid #CFCFCF;
    border-radius: 4px;

    label{
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
      font-weight: 500;
      font-size: 13px;
      cursor: pointer;
    }
  }

  .nome-completo{ background: #F7F8F9; }


  .acoes-form{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-top: 24px;

    button{ margin: 0; padding: 0 28px; }
  }

  .cancelar{
    display: inline-flex;
    align-items: center;
    height: 42px;
    padding: 0 22px;
    border-radius: 3px;
    border: 1.2px solid var(--primary-color);
    color: var(--primary-color);
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;

    &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
  }

  .geral{ margin-top: 12px; font-size: 12px; color: #C43333; }
`;
